import React, { useEffect, useState, useMemo } from "react";
import Navbar from "../../Navbar";
import {
  Container,
  Typography,
  ListItemIcon,
  Button,
  Tooltip,
  MenuItem,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { Delete } from "@mui/icons-material";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import PersonIcon from "@mui/icons-material/Person";
import PeopleIcon from "@mui/icons-material/People";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { getData, putData } from "../../../services/library";
import BajaProductoEnv from "./baja/BajaProductoEnv";
import EdicionProducto from "./edicion/EdicionProducto";
import AltaProductoEnv from "./alta/AltaProductoEnv";
import MarcarActivoEnv from "./activo/MarcarActivoEnv";

function ProductoEnvasado() {
  const [productos, setProductos] = useState(); //aca se almacenan los datos que me trae la api
  const [alta, setAlta] = useState(false); //Estado q mostrará o no la pantalla de alta
  const [tabla, setTabla] = useState(true); //Estado q mostrará o no la tabla (pantalla inicial) dnd estan los clientes
  const [editar, setEditar] = useState(false); //Estado q mostrará o no el form de edicion de clientes
  const [baja, setBaja] = useState(false); //Abre formulario
  const [dataProducto, setDataProducto] = useState({});
  const [marcarActivo, setMarcarActivo] = useState(false);
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });

  //Tabla
  const [hiddenmuestrainactivo, setHiddenmuestrainactivo] = useState(false);
  const [hiddenmuestraactivos, setHiddenmuestraactivos] = useState(true);

  const obtenerProductosInactivos = () => {
    setHiddenmuestrainactivo(true);
    setHiddenmuestraactivos(false);
    getData("/envasado_productos/inactivos", setProductos);
  };

  const obtenerProductos = () => {
    setHiddenmuestraactivos(true);
    setHiddenmuestrainactivo(false);
    getData("/envasado_productos/", setProductos);
  };

  useEffect(() => {
    obtenerProductos();
  }, [tabla]);

  const handleClickNuevo = () => {
    setAlta(true); //pongo alta en true para q muestre el componente Addcliente
  };

  const handleCloseEditar = () => {
    setEditar(false);
    setTabla(true);
    obtenerProductos();
  };
  const handleCloseAlta = () => {
    setAlta(false);
    setTabla(true);
    obtenerProductos();
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "id", //access nested data with dot notation
        header: "ID",
        maxSize: 100,
      },
      {
        accessorKey: "codigo", //access nested data with dot notation
        header: "Código",
        maxSize: 100,
      },
      {
        accessorKey: "nombre", //access nested data with dot notation
        header: "Nombre",
      },
      {
        accessorKey: "peso", //access nested data with dot notation
        header: "Peso",
      },
      {
        accessorKey: "abreviatura", //access nested data with dot notation
        header: "Abreviatura",
      },
    ],
    [],
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const displayColumnDefOptions = {
    "mrt-row-actions": {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  };

  return (
    <>
      <Navbar />
      <Container maxWidth="xl" disableGutters sx={{ mb: 2, mt: 1 }}>
        {tabla && (
          <MaterialReactTable
            localization={MRT_Localization_ES}
            columns={columns}
            data={productos ?? [{}]}
            layoutMode={"grid"}
            initialState={initialState}
            enableColumnActions={false} //deshabilita las acciones POR COLUMNA
            enableGlobalFilterModes={false}
            enableHiding={false}
            enableRowActions={true}
            enableColumnFilters={false}
            enableFullScreenToggle={false}
            positionActionsColumn={"last"}
            enableExpandAll={false}
            enableToolbarInternalActions={true}
            muiTableHeadCellProps={tableHeadCellProps}
            muiSearchTextFieldProps={muiSearchTextFieldProps}
            enableDensityToggle={false}
            displayColumnDefOptions={displayColumnDefOptions}
            enableColumnResizing={true}
            muiTableBodyCellProps={({ row }) => ({
              align: "left",
              sx: {
                backgroundColor:
                  row.original.activo === 1 ? "#b3e6b3" : "#efc3c3",
                color: "black",
              },
            })}
            renderTopToolbarCustomActions={() => (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddBoxTwoToneIcon color="asd" />}
                  onClick={handleClickNuevo}
                >
                  Nuevo Producto
                </Button>
                <Typography variant="poster" fontSize={26}>
                  <PeopleIcon sx={{ fontSize: 20 }} />
                  Productos de Envasados
                </Typography>
              </>
            )}
            renderToolbarInternalActions={() => (
              <>
                {!hiddenmuestrainactivo ? (
                  <Tooltip title="Muestra Inactivos">
                    <IconButton
                      onClick={() => obtenerProductosInactivos()}
                      color="error"
                    >
                      <PersonOffIcon />
                    </IconButton>
                  </Tooltip>
                ) : null}
                {!hiddenmuestraactivos ? (
                  <Tooltip title="Mostrar ACTIVOS" color="success">
                    <IconButton onClick={() => obtenerProductos()}>
                      <PersonIcon />
                    </IconButton>
                  </Tooltip>
                ) : null}
              </>
            )}
            renderRowActionMenuItems={({ closeMenu, row, index }) => [
              <MenuItem
                key={index}
                style={{
                  display: row.original.activo === 0 ? null : "none",
                }}
                disabled={row.original.activo === 1}
                onClick={() => {
                  setMarcarActivo(true);
                  setDataProducto(row.original);
                  closeMenu();
                }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <CheckCircleOutlineIcon color="success" />
                </ListItemIcon>
                Marcar Activo
              </MenuItem>,

              <MenuItem
                key={index}
                style={{
                  display: row.original.activo === 0 ? "none" : null,
                }}
                disabled={row.original.activo === 0}
                onClick={() => {
                  closeMenu();
                  setDataProducto(row.original);
                  setEditar(true);
                }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <BorderColorIcon color="primary" />
                </ListItemIcon>
                Editar
              </MenuItem>,

              <MenuItem
                key={index}
                style={{
                  display: row.original.activo === 0 ? "none" : null,
                }}
                disabled={row.original.activo === 0}
                onClick={() => {
                  closeMenu();
                  setDataProducto(row.original);
                  setBaja(true);
                }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <Delete color="error" />
                </ListItemIcon>
                Marcar Inactivo
              </MenuItem>,
            ]}
          />
        )}
        {baja && (
          <BajaProductoEnv
            open={baja}
            setOpen={setBaja}
            producto={dataProducto}
            tabla={setTabla}
            actualizar={obtenerProductos}
          />
        )}
        {editar ? (
          <EdicionProducto
            editar={editar}
            datosRow={dataProducto}
            onClose={() => handleCloseEditar(false)}
          />
        ) : null}
        {alta ? (
          <AltaProductoEnv alta={alta} onClose={() => handleCloseAlta(false)} />
        ) : null}
        {marcarActivo ? (
          <MarcarActivoEnv
            open={marcarActivo}
            setOpen={setMarcarActivo}
            producto={dataProducto}
            tabla={setTabla}
            actualizar={obtenerProductos}
          />
        ) : null}
      </Container>
    </>
  );
}

export default ProductoEnvasado;
